<template>
  <div class="benefits-club">
    <div class="tool-title mb-4">
      Club de benefícios
    </div>
    <div class="filter-box">
      <i class="icon-search"></i>
      <input v-model="search" type="text" placeholder="Pesquisar" />
    </div>

    <action-dispatcher action="marketplace/getProducts" ref="actionDispatcher">
      <div class="row">
        <div
          v-for="(product, index) in filteredProducts"
          :key="index"
          class="col-lg-4 col-md-6 py-4 d-flex aling-items-strech"
        >
          <product-link :product="product" class="w-100" />
        </div>
      </div>
    </action-dispatcher>
  </div>
</template>

<script>
import ProductLink from "@/components/marketplace/ProductLink";
import { mapState } from "vuex";

export default {
  components: { ProductLink },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    ...mapState("marketplace", ["products"]),
    filteredProducts() {
      return this.products.filter(p =>
        p.title.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.benefits-club {
  .filter-box {
    padding: 16px 24px;
    background-color: rgba(36, 36, 36, 1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 16px;
    position: relative;

    i {
      font-size: 20px;
    }
    i,
    input {
      background-color: transparent;
      border: none;
      outline: none;
      color: white;
    }
    input::placeholder {
      color: rgba(146, 143, 152, 1);
    }
  }
  ::v-deep .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: unset;
  }
}
</style>
